/* unplugin-vue-components disabled */import { render } from "./MailIndicator.vue?vue&type=template&id=2073b854"
import script from "./MailIndicator.vue?vue&type=script&lang=js"
export * from "./MailIndicator.vue?vue&type=script&lang=js"

import "./MailIndicator.vue?vue&type=style&index=0&id=2073b854&lang=scss"
script.render = render

export default script